import store from '../../admin/store'
import { SET_API_STATUS } from '../../admin/reducers/api-checker'
const Firebase = window?.['firebase']

/**
 * Get ENVIRONMENT based on API url
 *
 * @return {string}
 */
export const getEnvByAPI = () => {
    const apiUrl = window.APP_CONFIG.REACT_APP_API_URL

    if (apiUrl.includes('sandbox') || apiUrl.includes('.local')) {
        return 'sandbox'
    }

    if (apiUrl.includes('staging')) {
        return 'staging'
    }

    return 'production'
}

/**
 * Get Firebase realtime database
 *
 * @return {boolean|*}
 */
export const getDatabase = () => {
    const database = Firebase?.database?.()

    if (!database) {
        // eslint-disable-next-line no-console
        console.error('Firebase database not defined')
        return false
    }

    return database
}

/**
 * Init API checker - check status and save it into store
 */
export const initApiChecker = () => {
    const database = getDatabase()

    if (!database) {
        return
    }

    const databaseRef = database.ref(`online_status/${getEnvByAPI()}`)

    databaseRef.on('value', snapshot => {
        store.dispatch({
            type: SET_API_STATUS,
            status: snapshot?.val?.()?.status,
        })
    })
}
